<template>
  <div class="text-right" v-if="store.calcOrderTotalPriceNoVat() > 0">
    <div class="row" style="font-weight: 600; font-size: 16px;">
      <div class="col-6 pr-0 text-left">
        {{ t('vat.price') }} {{ t('vat.withoutVat') }}:
      </div>
      <div class="col-6 text-secondary">
        {{ totalPriceNoVat }}
      </div>
    </div>
    <div class="row mb-1" style="font-size: 14px;">
      <div class="col-6 text-left">
        {{ t('vat.price') }} {{ t('vat.withVat') }}:
      </div>
      <div class="col-6">
        {{ totalPriceWithVat }}
      </div>
    </div>

  </div>
</template>

<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {ref} from 'vue'

export default {
  name: "TotalPrice",
  data() {
    return {
      store
    }
  },
  setup() {
    const {t, locale} = useI18n({useScope: 'global'})
    const select = ref(0)
    const lang = locale
    return {t, select, lang}
  },
  computed: {
    totalPriceNoVat() {
      var price = store.calcOrderTotalPriceNoVat()
      return store.priceFilter(price);
    },
    totalPriceWithVat() {
      var price = store.calcOrderTotalPriceWithVat()
      return store.priceFilter(price);
    },


  }

}
</script>

<style scoped>

</style>